import { Fragment, useState, useRef } from 'react'
import navigation from '@src/navigation/vertical'
import classnames from 'classnames'
import PerfectScrollbar from 'react-perfect-scrollbar'
import VerticalMenuHeader from './VerticalMenuHeader'
import VerticalNavMenuItems from './VerticalNavMenuItems'
import Select, { components } from "react-select";
import { Col, } from 'reactstrap'
import logo from '../../../../../assets/images/logo/SMARTER (Transparent).png'
import { useEffect } from 'react'
import { getCustomerList } from '../../../../../views/store/action'
import { useDispatch, useSelector } from "react-redux";
import { formatOptionLabel, getUserData, extractDropdown } from '../../../../../utility/Utils'
import ability from '@configs/acl/ability'
import { setFilterValues } from '../../../../../views/Components/Datatable/store/action'
import { customStyles } from '../../../../../utility/Utils'
import { Trash, X, XCircle, } from 'react-feather'
import { NavLink } from "react-router-dom"
const Sidebar = props => {
    const { menuCollapsed, routerProps, currentActiveItem, skin, menu } = props
    const [groupOpen, setGroupOpen] = useState([])
    const [groupActive, setGroupActive] = useState([])
    const [activeItem, setActiveItem] = useState(null)
    const [menuHover, setMenuHover] = useState(false)
    const shadowRef = useRef(null)
    const [currentActiveGroup, setCurrentActiveGroup] = useState([])

    const dispatch = useDispatch()

    const { dealerships, } = useSelector(state => state.customer)
    const { customer_id, selectedFilterVal } = useSelector(state => state.datatable)

    const MoreSelectedBadge = ({ items }) => {
        const title = items.join(", ");
        const length = items.length;
        const label = `+ ${length} item${length !== 1 ? "s" : ""} selected`;
        return (
            <div className='custom-option-selected' title={title}>   {label}   </div>
        );
    };

    const formatOptionLabel = (props) => (
        <div className="d-flex flex-direction-column">
            <div className='d-flex justify-content-between'>
                <span>{props.label}</span>
                {props.value &&
                    selectedFilterVal?.dealerships &&
                    selectedFilterVal.dealerships.map((item, index) =>
                        index !== 0 &&
                            item.value === props.value ? (
                            <span className='cursor-pointer'><XCircle size={15} /></span>
                        ) : null
                    )
                }
            </div>
            <span style={{ fontStyle: "italic", fontSize: "12px" }}>{props?.info ? `(${props?.info})` : ''}</span>
        </div>

    );

    const MultiValue = ({ index, getValue, ...props }) => {
        const maxToShow = 1;
        const overflow = getValue().slice(maxToShow).map((x) => x.label);
        return index < maxToShow ? (<components.MultiValue {...props} />
        ) : index === maxToShow ? (<MoreSelectedBadge items={overflow} />) : null;
    };

    const onMouseEnter = () => {
        if (menuCollapsed) { setMenuHover(true) }
    }

    useEffect(() => {
        dispatch(getCustomerList())
    }, []);

    const handleSelectFilter = (selctedCustomer) => {
        const result = extractDropdown(selctedCustomer, "All Dealerships")
        dispatch(setFilterValues({ ...selectedFilterVal, dealerships: result.items }))
        if (selctedCustomer && selctedCustomer?.length > 0) {
            dispatch({ type: 'SET_DEALERSHIP_FILTER', payload: result.ids.join(',') });
        } else {
            dispatch({ type: 'SET_DEALERSHIP_FILTER', payload: null });
        }
    }

    const scrollMenu = container => {
        if (shadowRef && container.scrollTop > 0) {
            if (!shadowRef.current.classList.contains('d-block')) {
                shadowRef.current.classList.add('d-block')
            }
        } else {
            if (shadowRef.current.classList.contains('d-block')) {
                shadowRef.current.classList.remove('d-block')
            }
        }
    }

    return (

        <Fragment>
            <div
                className={classnames('main-menu menu-fixed menu-accordion menu-shadow', {
                    expanded: menuHover || menuCollapsed === false, 'menu-light': skin !== 'semi-dark' && skin !== 'dark', 'menu-dark': skin === 'semi-dark' || skin === 'dark'
                })}
                onMouseEnter={onMouseEnter}
                onMouseLeave={() => setMenuHover(false)}
            >
                <Fragment >
                    {/* Vertical Menu Header */}
                    <VerticalMenuHeader setGroupOpen={setGroupOpen} menuHover={menuHover} {...props} />
                    {/* Vertical Menu Header Shadow */}
                    <div className='shadow-bottom' ref={shadowRef}></div>
                    {ability.can('manage', 'all') || (ability.can('manage', 'dealerships')) ?
                        <div className="d-flex justify-content-center m-1">

                            <Col sm={12} md={12} lg={12} xl={12}>
                                <Select
                                    hideSelectedOptions={false}
                                    styles={customStyles}
                                    isMulti={true}
                                    options={dealerships.filter(item => item.status === 1)}
                                    onChange={(e) => handleSelectFilter(e)}
                                    value={selectedFilterVal?.dealerships}
                                    components={{ MultiValue }}
                                    isSearchable={true}
                                    className='cursor-pointer'
                                    formatOptionLabel={formatOptionLabel}
                                    placeholder="Switch Dealership" >

                                </Select>

                            </Col>
                        </div>
                        : ''}

                    <PerfectScrollbar
                        className="main-menu-content" options={{ wheelPropagation: false }} onScrollY={(container) => scrollMenu(container)} >
                        <div className='mt-1'>
                            <ul className='navigation navigation-main'>
                                <VerticalNavMenuItems
                                    items={navigation}
                                    isMenuParent={true}
                                    groupActive={groupActive}
                                    setGroupActive={setGroupActive}
                                    activeItem={activeItem}
                                    setActiveItem={setActiveItem}
                                    groupOpen={groupOpen}
                                    setGroupOpen={setGroupOpen}
                                    routerProps={routerProps}
                                    menuCollapsed={menuCollapsed}
                                    menuHover={menuHover}
                                    currentActiveItem={currentActiveItem}
                                    currentActiveGroup={currentActiveGroup}
                                    setCurrentActiveGroup={setCurrentActiveGroup}
                                />
                            </ul>
                        </div>

                    </PerfectScrollbar>
                    <div className='top-100 position-sticky'>
                        <hr />
                        <div className="navbar-header">
                            <ul className="nav navbar-nav flex-row">
                                <li className="nav-item me-auto">
                                    <img className='main-logo' src={logo} />
                                </li>
                            </ul>
                        </div>

                    </div>
                </Fragment>

            </div >
        </Fragment >


    )
}

export default Sidebar
